const UpdateData = (dispatch, type, payload) => {
  dispatch({ type, payload });
};

export default UpdateData;
